<rp-icon class="coming-soon__icon" size="4xl" [iconName]="icons.ComingSoon" />

<div class="coming-soon">
  <h2 class="coming-soon__title">{{ 'comingSoon.title' | translate }}</h2>
  <p class="coming-soon__message">{{ 'comingSoon.message' | translate }}</p>
</div>
